module.exports = __webpack_public_path__ + "static/media/thank-you.6a6501f2.png";